import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import MaskedInput from 'react-text-mask';
import Api from 'service/api';

const TextMaskCustom = (props) => {
    const { inputRef, ...other } = props;
    const currentLang = window.localStorage.i18nextLng;
    return (
        <MaskedInput
            {...other}
            ref={(ref) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={
                currentLang === 'en'
                    ? [/\d/, /\d/, /\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/]
                    : [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
            }
            placeholderChar={'\u2000'}
        />
    );
};

const useModalAddMessage = ({
    selectedSessionId,
    mudarStatusSessao,
    handleLinkCommunication,
    onClose,
    setOptions,
    setShowOptions,
    setShowInputBar,
    setMessages,
    LogoImg,
}) => {
    const [loadingPage, setLoadingPage] = useState(true);
    const [transitionIn, setTransitionIn] = useState(false);
    const [loadingForm, setLoadingForm] = useState(false);
    const [hasSelectMultiple, setHasSelectMultiple] = useState(false);
    const [area, setArea] = useState('');
    const [tipo, setTipo] = useState('');
    const [regional, setRegional] = useState('');
    const [data, setData] = useState('');
    const [dataFim, setDataFim] = useState('');
    const [cid, setCid] = useState('');
    const [previewFotos, setPreviewFotos] = useState([]);
    const [filesFotos, setFileFotos] = useState([]);
    const [comentario, setComentario] = useState('');
    const [isAtestado, setIsAtestado] = useState(false);
    const [fieldErrors, setFieldErrors] = useState([]);
    const [openAlert, setOpenAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');
    const [optionsArea, setOptionsArea] = useState([]);
    const [optionsCategories, setOptionsCategories] = useState([]);
    const [optionsTipo, setOptionsTipo] = useState([]);
    const [optionsRegional, setOptionsRegional] = useState([]);
    const { t: translate } = useTranslation();
    const [anexoRequiredList, setAnexoRequiredList] = useState([]);

    const handleChangeArea = (event) => {
        getFilteredCategories(event.target.value);
        setArea(event.target.value);
        setTipo(event.target.value === 'Pagamentos Fixos e Variáveis' ? [] : '');
        setFieldErrors(fieldErrors.filter((inp) => inp.name !== 'area'));
        setHasSelectMultiple(event.target.value === 'Pagamentos Fixos e Variáveis' ? true : false);
    };

    const handleChangeTipo = (event) => {
        setTipo(event.target.value);
        setFieldErrors(fieldErrors.filter((inp) => inp.name !== 'tipo'));
    };

    const handleRemoveItemSelect = (value) => {
        setTipo(tipo.filter((item) => item !== value));
    };

    const handleChangeRegional = (event) => {
        setRegional(event.target.value);
        setFieldErrors(fieldErrors.filter((inp) => inp.name !== 'regional'));
    };

    const handleChangeData = (event) => {
        setData(event.target.value);
        setFieldErrors(fieldErrors.filter((inp) => inp.name !== 'data'));
    };

    const handleChangeDataFim = (event) => {
        setDataFim(event.target.value);
        setFieldErrors(fieldErrors.filter((inp) => inp.name !== 'dataFim'));
    };

    const handleChangeCid = (event) => {
        setCid(event.target.value);
        setFieldErrors(fieldErrors.filter((inp) => inp.name !== 'cid'));
    };

    const handleChangeComentario = (event) => {
        setComentario(event.target.value);
        setFieldErrors(fieldErrors.filter((inp) => inp.name !== 'comentario'));
    };

    const handleChangeFotos = (event) => {
        let input = event.currentTarget;
        let validImageTypes = ['image/jpg', 'image/jpeg', 'image/png', 'application/pdf'];

        if (input.files && input.files[0]) {
            let img = URL.createObjectURL(input.files[0]);
            let fileName = input.files[0].name;
            if (validImageTypes.indexOf(input.files[0]['type']) !== -1) {
                setPreviewFotos([...previewFotos, { img, fileName }]);
                setFileFotos([...filesFotos, input.files]);
                setFieldErrors(fieldErrors.filter((inp) => inp.name !== 'fotos'));
            }
        }
    };

    const handleRemoveFoto = (foto) => {
        setPreviewFotos(previewFotos.filter((item) => item !== foto));
        // Note: clearing the input value might be tricky if there are multiple inputs or if we want to keep others
        // But following original logic:
        const fileInput = document.querySelector('button [type=file]');
        if (fileInput) fileInput.value = null;
    };

    const validateForm = () => {
        let errors = 0;
        let filelds = [];
        const msgAnexo = document.getElementById('msg-anexo');
        if (msgAnexo) msgAnexo.innerText = '';

        if (area === '') {
            filelds.push({ name: 'area', error: true });
            errors++;
        }

        if (tipo === '') {
            filelds.push({ name: 'tipo', error: true });
            errors++;
        }

        if (regional === '') {
            filelds.push({ name: 'regional', error: true });
            errors++;
        }

        if (anexoRequiredList.includes(area) && data === '') {
            filelds.push({ name: 'data', error: true });
            errors++;
        }

        if (data !== '' && !moment(data, 'YYYY-MM-DD').isValid()) {
            filelds.push({ name: 'data', error: true });
            errors++;
        }

        if (isAtestado && dataFim === '') {
            filelds.push({ name: 'dataFim', error: true });
            errors++;
        }

        if (comentario === '') {
            filelds.push({ name: 'comentario', error: true });
            errors++;
        }

        if (anexoRequiredList.includes(area) && filesFotos.length === 0) {
            if (msgAnexo) msgAnexo.innerText = `Anexo Obrigatório para ${area}`;
            errors++;
        }

        setFieldErrors(filelds);
        return { errors, filelds };
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const { errors } = validateForm();
        if (errors > 0) {
            setMessageAlert(translate('addMessage.formValidade'));
            setOpenAlert(true);
            return false;
        }

        setLoadingForm(true);

        let arquivos = [];

        filesFotos.forEach((file) => {
            arquivos.push(file[0]);
        });

        try {
            const response = await Api.post('comunicacao-altum', {
                area,
                regional,
                comentario,
                arquivos,
                tipo: Array.isArray(tipo) ? tipo.join('/') : tipo,
                mes_referencia: data,
                data_termino: dataFim,
                cid,
            });

            const idComunicacaoInterna = response.data?.data?.cmit_id_comunicacao_interna;

            if (idComunicacaoInterna && selectedSessionId) {
                if (handleLinkCommunication) {
                    await handleLinkCommunication(idComunicacaoInterna);
                }

                if (mudarStatusSessao) {
                    await mudarStatusSessao('COMUNICACAO_RESPONSAVEL_PENDENTE');
                }
            }

            setLoadingForm(false);
            if (onClose) onClose();

            if (setMessages && LogoImg) {
                setMessages((prev) => [
                    ...prev,
                    {
                        remetente: 'ISA',
                        texto: 'Em breve um atendente entrará em contato, por favor aguarde',
                        avatar: LogoImg,
                        isOption: false,
                    },
                ]);
            }

            setOptions([{ key: 'ver_comunicacao_interna', label: 'Ver Comunicação Interna' }]);
            //if (setShowOptions) setShowOptions(false);
            if (setShowInputBar) setShowInputBar(true);
        } catch (error) {
            setLoadingForm(false);

            // Verificar se existe response
            if (!error.response) {
                setMessageAlert('Erro de conexão. Verifique sua internet e tente novamente.');
                setOpenAlert(true);
                return;
            }

            // Verificar o status code para erro de validação
            if (error.response.status === 400) {
                // Tentar parsear manualmente se data estiver undefined
                if (!error.response.data && error.request.responseText) {
                    try {
                        const parsedData = JSON.parse(error.request.responseText);

                        if (parsedData.error && parsedData.error.type === 'VALIDATION_ERROR') {
                            setMessageAlert(parsedData.error.message);
                            setOpenAlert(true);
                            return;
                        }
                    } catch (e) {
                        // Silenciar erro de parsing
                    }
                }

                // Se data existir, processar normalmente
                if (error.response.data) {
                    const errorData = error.response.data.error || error.response.data;

                    if (errorData && errorData.type === 'VALIDATION_ERROR') {
                        setMessageAlert(errorData.message);
                        setOpenAlert(true);
                        return;
                    }

                    if (error.response.data.message) {
                        setMessageAlert(error.response.data.message);
                        setOpenAlert(true);
                        return;
                    }
                }

                // Mensagem específica para status 400
                setMessageAlert('Dados inválidos. Verifique os campos e tente novamente.');
                setOpenAlert(true);
                return;
            }

            // Mensagem genérica para outros erros
            setMessageAlert(translate('addMessage.errorSubmit') || 'Erro ao enviar a solicitação. Tente novamente.');
            setOpenAlert(true);
        }
    };

    const listAreas = async () => {
        try {
            const resp = await Api.get('client/settings/areas');
            let requiredList = [];
            if (resp.data.areas.length > 0) {
                const list = resp.data.areas.map((item) => {
                    if (item.attachment_is_required) {
                        requiredList.push(item.name);
                    }
                    return {
                        value: item.name,
                        label: item.name,
                    };
                });
                setOptionsArea(list);
                setAnexoRequiredList(requiredList);
            }
        } catch (e) {
            console.error(e);
        }
    };

    const listCategorias = async () => {
        try {
            const resp = await Api.get('client/settings/categories');
            if (resp.data.categories.length > 0) {
                const list = resp.data.categories.map((item) => {
                    return {
                        value: item.name,
                        label: item.name,
                        areaName: item.area.name,
                    };
                });
                setOptionsCategories(list);
            }
        } catch (e) {
            console.error(e);
        }
    };

    const listRegional = async () => {
        try {
            const resp = await Api.get('client/settings/locations');
            if (resp.data.locations.length > 0) {
                const list = resp.data.locations.map((item) => {
                    return {
                        value: item.name,
                        label: item.name,
                    };
                });
                setOptionsRegional(list);
            }
        } catch (e) {
            console.error(e);
        }
    };

    function getFilteredCategories(area) {
        const list = optionsCategories.filter((item) => item.areaName === area);
        setOptionsTipo(list);
    }

    function camposAtestado() {
        const atestadoKeywords = ['Atestados', 'Afastamentos', 'Ausências', 'Atestado'];
        if (atestadoKeywords.some((keyword) => area === keyword || area.includes(keyword))) {
            setIsAtestado(true);
            return;
        }
        setIsAtestado(false);
        setCid('');
        setDataFim('');
    }

    useEffect(() => {
        setTimeout(() => {
            setLoadingPage(false);
        }, 200);

        setTimeout(() => {
            setTransitionIn(true);
        }, 300);

        listAreas();
        listCategorias();
        listRegional();
        camposAtestado();
    }, [area]);

    const handleClose = () => {
        if (onClose) onClose();

        if (setOptions) {
            setOptions([
                { key: 'comunicacao_interna_iniciar', label: 'Continuar com a Comunicação Interna' },
                { key: 'comunicacao_interna_cancelar', label: 'Cancelar Comunicação Interna' },
            ]);
        }
        if (setShowOptions) setShowOptions(true);
        if (setShowInputBar) setShowInputBar(false);
    };

    return {
        transitionIn,
        loadingPage,
        loadingForm,
        hasSelectMultiple,
        optionsArea,
        optionsRegional,
        area,
        tipo,
        regional,
        data,
        dataFim,
        cid,
        previewFotos,
        comentario,
        fieldErrors,
        openAlert,
        messageAlert,
        optionsTipo,
        isAtestado,
        setOpenAlert,
        handleChangeArea,
        handleChangeTipo,
        handleRemoveItemSelect,
        handleChangeRegional,
        handleChangeData,
        handleChangeDataFim,
        handleChangeCid,
        handleChangeFotos,
        handleRemoveFoto,
        handleChangeComentario,
        TextMaskCustom,
        handleSubmit,
        translate,
        handleClose,
    };
};

export default useModalAddMessage;
